import React from "react";

const FirstTask = ({ label }) => {
  return (
    <div className="w-48 h-10 bg-neutral-700 rounded-2xl flex items-center justify-center">
      <span className="text-white text-sm font-medium">{label}</span>
    </div>
  );
};

export default FirstTask;
